import Vue from 'vue'
import { Tabs, TabPane, Select, Option, Dialog, Button } from 'element-ui'

Vue.use(Tabs).use(TabPane).use(Select).use(Option).use(Dialog).use(Button)
